module.exports = __webpack_public_path__ + "media/picrossvs.6ed5248a.mp4";